import React, { useEffect, useState } from "react";
import { createComponentStore } from "easy-peasy";
import UserStoreModel, { ACTION_TYPES } from "store/models/user";
import { Table } from "antd";
import moment from "moment";
import { formatDate } from "Utils";

const useStoreStore = createComponentStore(UserStoreModel);

export default function UserGroupUsersRoute({ id, ...props }) {
  const [store, actions] = useStoreStore();

  useEffect(() => {
    actions.getUserGroupItems({ object: { id: id } });
  }, []);

  const columns = [
    {
      title: "Ad Soyad",
      dataIndex: "name",
      render: (text, record) => {
        return `${record.userId?.name} ${record.userId?.surname}`;
      },
    },
    {
      title: "E-Posta",
      dataIndex: ["userId", "email"],
    },
    {
      title: "Yaratma Tarihi",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text, record) => {
        return formatDate(record.createdAt);
      },
    },
  ];

  return (
    <Table
      loading={store.process === ACTION_TYPES.FETCHING_GROUP_AUTHS_BY_ID}
      bordered
      rowKey={(row) => row.id}
      dataSource={store.userGroupItems}
      columns={columns}
      size="small"
    />
  );
}
